<template>
  <ComponentsLayoutWithNavbar
    id="bids-history-by-lot"
    main_color="var(--color-main-green)">
    <template #breadcrumbs>
      <TenderBreadcrumbs :additional_breads="breads"/>
    </template>
    <template #main_content>
      <template v-if="loading">
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-10 pr-8"
          :tile="true"
          type="heading"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-3 pr-8"
          :tile="true"
          type="sentences"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-4 main__green mt-5"
          :tile="true"
          type=" table-thead, table-tbody"
          width="100%"/>
      </template>
      <v-card
        v-else
        class="width-100 px-0 main__green pt-3"
        elevation="0">
        <v-card-title class="h1-headline px-0 pt-2">
          {{ lot.title || '–' }}
        </v-card-title>
        <v-card-subtitle class="h8-text text-start pa-0 pt-1 black--text col-9">
          {{ tender.category ? tender.category.code + ' ' + tender.category.title : '' }}
        </v-card-subtitle>
        <BidHistoryScatterChart
          v-if="info.length"
          by="name"
          class="mr-2 mt-8"
          :items="info"
          :title="$t('Tenders.ReducingPriceOfLot')"/>
        <div
          id="offerstable-container"
          class="flex flex-wrap flex-direction-column pr-2 pt-2">
          <SearchInput
            class="mb-3"
            debounce
            :search.sync="search"
            small
            width="200px"
            @input="applySearch"/>
          <OffersTable
            :critery-card="criteryCard"
            :format-headers="formatHeaders"
            infinity
            infinity_selector="#offerstable-container"
            :items="searched"
            mode="history"
            :snackbar_open="snackbarOpen"
            :tender="tender"/>
        </div>
      </v-card>
    </template>
    <template #nav_bar="{ mini }">
      <div
        v-show="!mini"
        style="height: calc(100vh - 38px);">
        <template v-if="loading">
          <v-skeleton-loader
            class="mt-10 px-8"
            height="50px"
            type="heading"
            width="80%"/>
          <v-skeleton-loader
            v-for="(i, n) in new Array(3)"
            :key="n"
            class="mt-3 px-8"
            height="50px"
            type="sentences"
            width="100%"/>
        </template>
        <template v-else>
          <LotInfoBar
            :item="lot"
            :tender="tender"/>
        </template>
      </div>
      <div
        v-show="!mini"
        class="flex justify-center">
        <sButton
          data-qa="back-to-history"
          :to="{name: 'bidsHistory', params: { tenderId: tender.tenderId, org: $route.params.org}}"
          type="text">
          <sIcon
            class="s-btn-icon"
            rotate="90"
            size="10"
            type="long-arrow"/>
          {{ $t('Tenders.BackToHistory') }}
        </sButton>
      </div>
    </template>
  </ComponentsLayoutWithNavbar>
</template>
<script>
import SearchInput from 'components/common/inputs/SearchInput.vue'
import LotInfoBar from 'components/tenders/tender page/LotInfoBar.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import OffersTable from 'components/tenders/tender page/offersGroups/OffersTable.vue'
import ComponentsLayoutWithNavbar from 'pages/templates/ComponentsLayoutWithNavbar.vue'
import BidHistoryScatterChart from 'components/tenders/tender page/bids history/BidHistoryScatterChart.vue'

import moment from 'moment'
import { measureMixin, modalMixin, tenderMixin, bidHistoryHeadersMixin } from 'mixins'

export default {
  name: 'bidsHistoryByLot',
  mixins: [ measureMixin, modalMixin, tenderMixin, bidHistoryHeadersMixin ],
  data() {
    return {
      bids: [],
      info: [],
      tender: {},
      lot: {},
      loading: false,
      selected: [],
      search: '',
      searched: [],
      criteryCard: null,
      currencies: [] // Нужно для заполнения валюты подачи
    }
  },
  filters: {
    formatDateMonth(val) {
      return moment(val).format('DD MMMM')
    },
    formatTime(val) {
      return moment(val).format('HH:mm')
    },
    formatDate(value) {
      if (value) {
        return moment(value).format('DD.MM.YYYY, HH:mm')
      }
    },
  },
  async created() {
    this.setTenderMeasurements()
    await this.getItem()
  },
  computed: {
    breads() {
      return [
        {
          text: this.$t('Tenders.History'),
          to: {name: 'bidsHistory', params: { tenderId: this.tender.tenderId, org: this.$route.params.org}}
        },
        {
          text: this.$t('Tenders.Lots'),
          current: true
        },
        {
          text: this.lot?.title
        }
      ]
    },
    headers() {
      return [
        { text: '', value: 'data-table-select', width: '24px' },
        { text: this.$t('Tenders.Supplier') , value: 'name', width: '31%'  },
        { text: this.$t('Tenders.FilingDate'), value: 'timeSupplyBids', width: '19%'},
        { text: this.$t('Catalog.Amount'), value: 'quantity', width: '15%' },
        { text: this.$t('Catalog.Price'), value: 'price', width: '10%' },
        { text: this.$t('Tenders.TotalCostShort'), value: 'summ', width: '17%' },
        {text: '', value: 'isCanceled', width: '7%', sortable: false },
      ]
    }
  },
  methods: {
    async getItem(condition) {
      this.loading = true
      const promises = [
        await this.$store.dispatch('setCurrencies')
          .then((result) => {
            this.currencies = result
          }),
        await this.$store.dispatch('getTenderItem', {id: +this.$route.params.tenderId, condition: condition})
          .then(res => {
            this.tender = res
            this.lot = this.tender.lots.find(lot => lot.lotId == this.$route.params.lotId)
          }),

        await this.$store.dispatch('getTenderBidHistory', {tenderId: +this.$route.params.tenderId, model: {lotId: +this.$route.params.lotId}})
          .then(res => {
            if ( !res ) {
              this.$notice.closeAll()
              this.$notice.info({
                title: this.$t('Common.ErrorTitle'),
                message: this.$t('Errors.STHWrong'),
                showClose: true,
                progress: true,
                duration: 10
              })
              return this.$router.push({name: 'bidsHistory', params: { tenderId: this.tender.tenderId, org: this.$route.params.org}})
            }
            this.bids = this.getBids(res, this.tender)
            this.info = this.bids.map(bid => ({...bid,
              x: bid.timeSupplyBids,
              y: bid.currencyPrice }))
            this.searched = this.bids.slice(0)
          })
      ]

      await Promise.all(promises)
      await this.$store.dispatch('infoAboutCriterionCard', {save: true, id: this.tender.criteriaCard}).then(res => this.criteryCard = res)
      this.loading = false
    },
    formatHeaders(headers) {
      headers = headers.filter(el => el.value != 'lotTitle' && el.value != 'status')
      headers.splice(2, 0, ...this.$_bidHistoryDateHeaders)
      headers.splice(-1, 1,
        {text: '', value: 'isCanceled', width: '7%', sortable: false },
      )
      return headers
    },
    applySearch(search) {
      this.searched = this.bids.filter(bid => bid.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()) )
    },
    snackbarOpen(selected) {
      return {
        name: 'lot-offers-history',
        compare_name: 'lotHistoryComparativeTable',
        elements: selected,
        item: this.lot,
        tender: this.tender,
        callback: () => {
          selected = []
        }
      }
    },
  },
  components: {
    LotInfoBar,
    SearchInput,
    OffersTable,
    TenderBreadcrumbs,
    BidHistoryScatterChart,
    ComponentsLayoutWithNavbar
  }
}
</script>
